import {TaskListActionTypes} from 'constants/actionType';

export const setSelectedTask = ({taskID = null, taskNumber = null, cardID = null}) => ({
  type: TaskListActionTypes.SET_SELECTED_TASKS,
  tasks: {[taskNumber]: [{taskID, taskNumber, cardID}]},
});

export const setMultipleSelectedTasks = (tasks) => ({
  type: TaskListActionTypes.SET_SELECTED_TASKS,
  tasks,
});

export const removeSelectedTask = (taskId) => ({
  type: TaskListActionTypes.REMOVE_SELECTED_TASKS,
  taskIds: [taskId],
});

export const removeMultipleSelectedTasks = (taskIds) => ({
  type: TaskListActionTypes.REMOVE_SELECTED_TASKS,
  taskIds,
});

export const resetSelectedTasks = () => ({type: TaskListActionTypes.RESET_SELECTED_TASKS});
export const resetSelectedCards = () => ({type: TaskListActionTypes.RESET_SELECTED_CARDS});

export const setExpandedCardID = (ID) => ({
  type: TaskListActionTypes.SET_CARD_EXPANDED,
  ID,
});
